module.exports = __webpack_public_path__ + "static/media/caffe-arabica-250gr.642998e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/caffe-arabica-250gr.jpg
// module id = 818
// module chunks = 0